import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./CrearGrupo.css";
import { getAuthHeaders } from "../../utils/apiUtils";
import CustomModal from "../../components/CustomModal/CustomModal";
import PaymentModal from "../../components/PaymentModal/PaymentModal";

import imagenbienvenidapasouno from "../../assets/generales/grupo-ciclistas.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// --- Nuevo componente LoadingModal para la carga ---
const LoadingModal = ({ isOpen, message = "Procesando..." }) => {
  if (!isOpen) return null;

  return (
    // Utilizando clases de Bootstrap para el modal, backdrop y spinner
    <div
      className="modal d-block" // d-block para forzar visibilidad sin toggle de Bootstrap JS
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1050 }}
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center p-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3 mb-0">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
// --------------------------------------------------

const CrearGrupo = ({ onCreationComplete }) => {
  const navigate = useNavigate();
  const [pasoActual, setPasoActual] = useState(1);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultModalType, setResultModalType] = useState("");
  const [resultModalTitle, setResultModalTitle] = useState("");
  const [resultModalMessage, setResultModalMessage] = useState("");

  const [temas, setTemas] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  // --- Nuevo estado para el Modal de Carga ---
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  // -------------------------------------------

  const [grupoNombre, setGrupoNombre] = useState("");
  const [tema, setTema] = useState("");
  const [grupocerrado, setGrupocerrado] = useState("");
  const [grupoImagen, setGrupoImagen] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [grupoDescripcion, setGrupoDescripcion] = useState("");
  const [normasGrupo, setNormasGrupo] = useState("");

  const [planActivoId, setPlanActivoId] = useState(null);

  const fileInputRef = useRef(null);

  useEffect(() => {
    // Asumiendo que obtienes el token de alguna fuente, como localStorage o un contexto de autenticación.
    const token = getAuthHeaders();

    if (!token) {
      console.error("No se encontró el token de autorización.");
      setIsLoading(false);
      setApiError("Por favor, inicia sesión para acceder a esta función.");
      return;
    }

    const fetchInitialData = async () => {
      try {
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [temasResponse, planesResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/creargrupo/temas`, requestOptions),
          fetch(`${API_BASE_URL}/creargrupo/planes`, requestOptions),
        ]);

        if (!temasResponse.ok) {
          throw new Error("Error al cargar los temas.");
        }
        const temasData = await temasResponse.json();
        setTemas(temasData);

        if (!planesResponse.ok) {
          throw new Error("Error al cargar los planes.");
        }
        const planesData = await planesResponse.json();
        setPlanes(planesData);
      } catch (error) {
        console.error("Error al cargar datos de la API:", error);
        setApiError(
          "Ocurrió un error al cargar los datos. Por favor, inténtalo de nuevo más tarde."
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  const getActivePlan = async () => {
    try {
      const token = getAuthHeaders();

      const response = await fetch(`${API_BASE_URL}/creargrupo/plan-activo`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();

      // Asumimos que el backend devuelve { idplan: 1 } o { idplan: 2 } o { idplan: null }
      return responseData.idplan || null;
    } catch (error) {
      console.error("Error al obtener el plan activo:", error);
      // Si hay error (ej. 401 o no hay plan), asumimos que no tiene plan activo.
      return null;
    }
  };

  // Manejo de la lógica para el paso 2
  const selectedPlanData = planes.find((p) => p.id === planSeleccionado) || {};

  const handleNextStep = async (planId) => {
    // Si se está en el Paso 2 (Formulario de grupo)
    if (pasoActual === 2) {
      if (!isFormValidPaso2) return; // Validación defensiva

      // 1. Consultar el plan activo del usuario - INICIO DEL LOADING
      setShowLoadingModal(true); // <--- ACTIVAR LOADING AQUÍ

      const activeId = await getActivePlan();

      setShowLoadingModal(false); // <--- DESACTIVAR LOADING AQUÍ

      setPlanActivoId(activeId); // Guardar el plan activo en el estado

      // 2. Lógica de Salto (Si tiene Premium y no necesita pagar)
      // Requisito: Si el usuario ya tiene Premium (ID 2), no necesita pasar al Paso 3 y 4.
      if (activeId === 2) {
        // Flujo modificado: Forzamos la selección del plan Premium si ya lo tiene y pasamos al Paso 3
        //setPlanSeleccionado(activeId); // Seleccionamos Premium
        //setPasoActual(pasoActual + 1); // Pasamos al Paso 3 (Selección de Planes)
        handlePaymentSubmit(null, activeId); // Llamar a la creación del grupo con datos de pago nulos y plan activo.
        return; // Detener el flujo de pasos
      }
    }

    // Si se pasa un planId (desde el Paso 3)
    if (planId) setPlanSeleccionado(planId);

    // Flujo normal: avanzar al siguiente paso (Paso 1->2, 2->3, 3->4)
    setPasoActual(pasoActual + 1);
  };

  const handlePreviousStep = () => {
    setPasoActual(pasoActual - 1);
  };

  const handleGrupoNombreChange = (e) => {
    const nombre = e.target.value;
    setGrupoNombre(nombre);
  };

  const handleImageError = (title, message) => {
    setResultModalType("error");
    setResultModalTitle(title);
    setResultModalMessage(message);
    setShowResultModal(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 500 * 1024) {
        handleImageError(
          "Error al subir imagen",
          "El tamaño de la imagen no puede exceder los 500 KB."
        );
        setGrupoImagen(null);
        setPreviewUrl(null);
        return;
      }
      const fileType = file.type;
      if (
        fileType !== "image/jpeg" &&
        fileType !== "image/png" &&
        fileType !== "image/jpg"
      ) {
        handleImageError(
          "Error al subir imagen",
          "Solo se permiten archivos de tipo JPG, JPEG y PNG."
        );
        setGrupoImagen(null);
        setPreviewUrl(null);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
      setGrupoImagen(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const isFormValidPaso2 = grupoNombre.length >= 3 && tema !== "";

  const handlePayClick = () => {
    setShowPaymentModal(true);
  };

  const uploadGroupImage = async (grupoId) => {
    if (!grupoImagen) {
      return { success: true, message: "No se subió imagen." };
    }

    const token = getAuthHeaders();
    if (!token) {
      return { success: false, message: "Token no encontrado." };
    }

    const formData = new FormData();
    formData.append("idgrupo", grupoId);
    formData.append("imagen", grupoImagen);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/creargrupo/upload-image`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        // Usar status en Axios
        throw new Error(response.data.message || "Error al subir la imagen.");
      }

      const data = response.data;
      return { success: true, message: data.message };
    } catch (err) {
      console.error("Error al subir la imagen:", err);
      return {
        success: false,
        message: err.message || "Hubo un problema al subir la imagen.",
      };
    }
  };

  const handlePaymentSubmit = async (paymentData, skipPaymentPlanId = null) => {
    // Si viene de un flujo sin pago, definimos datos de pago y plan

    let isFreeCreation = false;
    let finalPlanId = planSeleccionado;

    if (skipPaymentPlanId === 2) {
      // Viene del Paso 2, saltando el pago porque tiene Premium.
      isFreeCreation = true;
      finalPlanId = 2;
    } else if (!paymentData) {
      console.error(
        "Error: Los datos de pago están incompletos o no se recibieron correctamente."
      );
      setResultModalType("error");
      setResultModalTitle("Error en el envío de datos");
      setResultModalMessage(
        "Hubo un problema con la información de pago. Inténtalo de nuevo."
      );
      setShowResultModal(true);
      return;
    }

    setShowPaymentModal(false);

    const token = getAuthHeaders();
    if (!token) {
      console.error("No se encontró el token de autenticación.");
      setResultModalType("error");
      setResultModalTitle("Error de Autenticación");
      setResultModalMessage("Por favor, inicia sesión para continuar.");
      setShowResultModal(true);
      return;
    }

    // --- ACTIVAR LOADING AQUÍ (Al darle 'Pagar') ---
    setShowLoadingModal(true);
    // ------------------------------------------------

    try {
      const requestBody = {
        tema: tema,
        titulo: grupoNombre,
        texto: grupoDescripcion,
        reglas: normasGrupo,
        tipogrupo: grupocerrado === "Si" ? "Si" : "No",

        idplan: finalPlanId,
        ...(isFreeCreation
          ? {}
          : {
              numbercar: paymentData.cardNumber,
              nombretitularcar: paymentData.cardholderName,
              mescarvenci: paymentData.expiryMonth,
              aniocervenci: paymentData.expiryYear,
              interccv: paymentData.cvv,
              tipocar: paymentData.cardType,
            }),
      };

      const response = await fetch(`${API_BASE_URL}/creargrupo/crear`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || "Error al crear el grupo.");
      }

      //Éxito en la creación del grupo. Ahora subimos la imagen.
      const grupoId = responseData.idgrupo;
      const imageUploadResult = await uploadGroupImage(grupoId);

      if (!imageUploadResult.success) {
        // Manejar el caso en que la creación del grupo fue exitosa, pero la imagen no.
        setResultModalType("warning");
        setResultModalTitle("Grupo Creado con Advertencia");
        setResultModalMessage(
          `Tu grupo ha sido creado, pero hubo un problema al subir la imagen: ${imageUploadResult.message}`
        );
      } else {
        // Ambos pasos fueron exitosos.
        setResultModalType("success");
        setResultModalTitle("¡Grupo Creado Exitosamente!");
        setResultModalMessage(
          `Tu grupo ha sido creado con éxito. Considera que: ${imageUploadResult.message}`
        );
      }

      setShowResultModal(true);
    } catch (err) {
      console.error("Error al procesar el pago:", err);
      setResultModalType("error");
      setResultModalTitle("¡Error en el Pago!");
      setResultModalMessage(
        err.message ||
          "Hubo un problema procesando tu pago. Por favor, verifica tus datos o intenta con otro método de pago."
      );

      setShowResultModal(true);
    } finally {
      // --- DESACTIVAR LOADING AQUÍ (Al finalizar el proceso) ---
      setShowLoadingModal(false);
      // ----------------------------------------------------------
    }
  };

  const handleResultModalClose = () => {
    setShowResultModal(false);
    if (resultModalType === "success" && onCreationComplete) {
      onCreationComplete();
      navigate("/list-group");
    } else if (resultModalType === "success") {
      navigate("/list-group");
    }
  };

  const renderPaso = () => {
    if (isLoading) {
      return (
        <div className="text-center mt-5">
          <p>Cargando datos...</p>
        </div>
      );
    }

    if (apiError) {
      return (
        <div className="text-center mt-5 text-danger">
          <p>{apiError}</p>
        </div>
      );
    }

    switch (pasoActual) {
      case 1:
        // Paso 1: Pantalla de bienvenida
        return (
          <div className="container-fluid crear-grupo-paso-1">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-lg-7 d-none d-lg-block">
                <img
                  src={imagenbienvenidapasouno}
                  alt="Grupo de personas felices"
                  className="img-fluid rounded-3"
                />
              </div>
              <div className="col-lg-5 col-md-12 text-center text-md-start mb-4 mb-lg-0">
                <div className="content-container mx-auto mx-md-0">
                  <h1 className="logo-conecta-title">
                    Únete a nuestra Plataforma
                  </h1>
                  <h2 className="content-title">
                    Crea tu comunidad en{" "}
                    <span className="content-subtitle">Conéctate Perú</span>
                  </h2>
                  <p className="lead mt-4">
                    Te ayudamos a crear tu comunidad para que puedas organizar
                    eventos, interactuar con otros grupos y promocionarte a una
                    red de miles de personas.
                  </p>
                  <ul className="list-unstyled content-list">
                    <li className="d-flex align-items-start mb-2 list-item">
                      <i className="bi bi-check-circle-fill me-2 icon-check"></i>
                      <p className="list-text">
                        Crea tu comunidad de la nada y hazla crecer a la
                        velocidad de la luz.
                      </p>
                    </li>
                    <li className="d-flex align-items-start mb-2 list-item">
                      <i className="bi bi-check-circle-fill me-2 icon-check"></i>
                      <p className="list-text">
                        Conéctate con gente que tiene intereses en común y
                        potencia tu red.
                      </p>
                    </li>
                    <li className="d-flex align-items-start mb-2 list-item">
                      <i className="bi bi-check-circle-fill me-2 icon-check"></i>
                      <p className="list-text">
                        Promociona tus eventos y haz que el mundo se entere de
                        lo que sucede en tu comunidad.
                      </p>
                    </li>
                  </ul>
                  <div className="w-100 text-center">
                    <button
                      onClick={() => handleNextStep()}
                      className="btn-primary btn-crear-grupo mt-4"
                    >
                      Crear grupo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 2:
        // Paso 2: Formulario para ingresar la información del grupo
        return (
          <div className="container-fluid crear-grupo-paso-2">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-12 col-md-10 p-4">
                <div className="d-flex align-items-center mb-5">
                  <button
                    onClick={handlePreviousStep}
                    className="btn btn-back me-3"
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <h2 className="step-title">Creando mi grupo</h2>
                </div>
                <div className="form-section mb-4">
                  <h3 className="section-title">
                    ¿Cuál es el tema principal de tu grupo?
                  </h3>
                  <p className="section-description">
                    Elige un tema para que sea más fácil de descubrir para las
                    personas interesadas.
                  </p>
                  <div className="row">
                    <div className="col-md-6">
                      {temas.slice(0, 6).map((t, index) => (
                        <div key={index} className="form-check tema-radio">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="temaRadio"
                            id={`tema${index}`}
                            value={t.cod} // Corrected: use t.cod for the value
                            checked={tema === t.cod} // Corrected: compare with t.cod
                            onChange={(e) => setTema(e.target.value)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`tema${index}`}
                          >
                            {t.nom} {/* Corrected: use t.nom for the label */}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="col-md-6">
                      {temas.slice(6).map((t, index) => (
                        <div key={index} className="form-check tema-radio">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="temaRadio"
                            id={`tema${index + 6}`}
                            value={t.cod} // Corrected: use t.cod for the value
                            checked={tema === t.cod} // Corrected: compare with t.cod
                            onChange={(e) => setTema(e.target.value)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`tema${index + 6}`}
                          >
                            {t.nom} {/* Corrected: use t.nom for the label */}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="form-section mb-4">
                  <h3 className="section-title">¿Cómo se llama tu grupo?</h3>
                  <div className="mb-3 form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="grupoNombre"
                      placeholder=" "
                      value={grupoNombre}
                      onChange={handleGrupoNombreChange}
                    />
                    <label htmlFor="grupoNombre">
                      Nombre de grupo (3 caracteres mínimo)
                    </label>
                  </div>
                </div>
                <div className="form-section mb-4">
                  <h3 className="section-title">
                    Sube una imagen para tu grupo
                  </h3>
                  <div
                    className="d-flex justify-content-center align-items-center image-upload-container rounded-3 mb-3"
                    onClick={triggerFileInput}
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                      accept="image/jpeg, image/png, image/jpg"
                    />
                    {previewUrl ? (
                      <img
                        src={previewUrl}
                        alt="Previsualización del grupo"
                        className="img-preview"
                      />
                    ) : (
                      <i className="bi bi-image icon-image-upload"></i>
                    )}
                  </div>
                </div>

                <div className="form-section mb-4">
                  <h3 className="section-title">
                    Cuéntanos un poco de que trata tu grupo
                  </h3>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Escribe una descripción"
                      id="grupoDescripcion"
                      style={{ height: "100px" }}
                      value={grupoDescripcion}
                      onChange={(e) => setGrupoDescripcion(e.target.value)}
                    ></textarea>
                    <label htmlFor="grupoDescripcion">Descripción</label>
                  </div>
                </div>

                <div className="form-section mb-4">
                  <h3 className="section-title">
                    Describe las normas de tu grupo
                  </h3>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Escribe normas para tu grupo"
                      id="normasGrupo"
                      style={{ height: "100px" }}
                      value={normasGrupo}
                      onChange={(e) => setNormasGrupo(e.target.value)}
                    ></textarea>
                    <label htmlFor="normasGrupo">Descripción</label>
                  </div>
                </div>

                <div className="form-section mb-4">
                  <h3 className="section-title">¿El grupo es cerrado?</h3>
                  <div className="row">
                    <div className="col-2 col-md-2">
                      <div className="form-check tema-radio">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="grupocerradoRadio"
                          id="gr1"
                          value="Si"
                          checked={grupocerrado === "Si"}
                          onChange={(e) => setGrupocerrado(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="gr1">
                          Si
                        </label>
                      </div>
                    </div>
                    <div className="col-2 col-md-2">
                      <div className="form-check tema-radio">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="grupocerradoRadio"
                          id="gr2"
                          value="No"
                          checked={grupocerrado === "No"}
                          onChange={(e) => setGrupocerrado(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="gr2">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section mb-4">
                  <h3 className="section-title">
                    ¿Por qué te interesa ingresar a este grupo?
                  </h3>
                  <div className="mb-3 form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="grupoUrl"
                      placeholder="El usuario podra indicar el motivo de unirse a tu grupo"
                      value=""
                      disabled
                      readOnly
                    />
                    <label htmlFor="grupoUrl" className="form-label-small">
                      El usuario podra indicar el motivo de unirse a tu grupo
                    </label>
                  </div>
                </div>

                <div className="w-100 text-center">
                  <button
                    onClick={() => handleNextStep()}
                    className="btn-primary btn-crear-grupo mt-4"
                    disabled={!isFormValidPaso2}
                  >
                    Continuemos
                  </button>
                </div>
              </div>
            </div>
            <CustomModal
              isOpen={showResultModal}
              title={resultModalTitle}
              message={resultModalMessage}
              type={resultModalType}
              onClose={handleResultModalClose}
            />
          </div>
        );

      case 3:
        // Paso 3: Selección de planes
        return (
          <div className="container-fluid crear-grupo-paso-3">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-10 col-md-12 p-4">
                <div className="d-flex align-items-center mb-5">
                  <button
                    onClick={handlePreviousStep}
                    className="btn btn-back me-3"
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <h2 className="step-title">
                    Elige el Plan que más se acomode a ti
                  </h2>
                </div>

                {planActivoId === 2 && (
                  <div className="alert alert-warning mb-4">
                    ⚠️ **Atención:** Actualmente tienes el Plan Premium. Si
                    seleccionas un plan inferior, podrías perder funcionalidades
                    (como el límite de grupos) y tu siguiente pago se ajustará
                    al plan seleccionado.
                  </div>
                )}
                {planActivoId === 1 && planSeleccionado === 2 && (
                  <div className="alert alert-success mb-4">
                    🎉 **¡Felicidades!** Estás actualizando al Plan Premium.
                    Esto te permitirá crear más grupos y acceder a todas las
                    funcionalidades.
                  </div>
                )}

                <div className="row justify-content-center">
                  {planes.map((plan) => {
                    const isCurrentPlan = plan.id === planActivoId;
                    const isDisabled = isCurrentPlan && plan.id !== 2; // Deshabilita el plan si ya lo tiene, EXCEPTO el Premium (ID 2) si el usuario quiere cambiar a uno inferior.

                    return (
                      <div key={plan.id} className="col-md-6 mb-4">
                        <div
                          className={`plan-card p-4 rounded-3 text-center ${
                            planSeleccionado === plan.id ? "selected" : ""
                          } ${isDisabled ? "disabled-plan" : ""}`} // Añadir clase para estilos de deshabilitado
                          onClick={() =>
                            !isDisabled && setPlanSeleccionado(plan.id)
                          } // Bloquear click si está deshabilitado
                          style={
                            isDisabled
                              ? { opacity: 0.5, pointerEvents: "none" }
                              : {}
                          } // Estilos inline para deshabilitar
                        >
                          <h3 className="plan-name">{plan.nombre}</h3>
                          <p className="plan-price">{plan.precio}</p>
                          <p className="plan-frecuencia">{plan.frecuencia}</p>

                          {isCurrentPlan && (
                            <span className="badge bg-secondary mb-2">
                              Plan Actual
                            </span>
                          )}

                          <button
                            className="btn-primary btn-plan"
                            disabled={isDisabled}
                          >
                            {isCurrentPlan ? "Plan Activo" : "Lo quiero!"}
                          </button>

                          <hr className="plan-divider" />
                          <div className="plan-features text-start">
                            <p className="plan-grupos mb-2">{plan.grupos}</p>
                            <ul className="list-unstyled">
                              {plan.caracteristicas.map(
                                (caracteristica, index) => (
                                  <li
                                    key={index}
                                    className={`feature-item ${
                                      caracteristica.aplica === 0
                                        ? "text-muted"
                                        : ""
                                    }`}
                                  >
                                    <i
                                      className={`bi me-2 ${
                                        caracteristica.aplica === 1
                                          ? "bi-check-circle-fill text-success"
                                          : "bi-x-circle-fill text-muted"
                                      }`}
                                    ></i>
                                    {caracteristica.nombre}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="w-100 mt-4 text-center">
                  <p className="text-muted small-disclaimer">
                    *Recuerda, si colocas frases relacionadas a temas sexuales e
                    ilícitos bloquearemos tu grupo sin opción a devolución del
                    costo de la membresía.
                  </p>
                </div>

                <div className="w-100 text-center">
                  <button
                    onClick={() => handleNextStep(planSeleccionado)}
                    className="btn-primary btn-crear-grupo mt-4"
                    disabled={!planSeleccionado}
                  >
                    Continuemos
                  </button>
                </div>
              </div>
            </div>
          </div>
        );

      case 4:
        // Paso 4: Resumen y pago
        return (
          <div className="container-fluid crear-grupo-paso-4">
            <div className="container-md-paso-4">
              <div className="d-flex align-items-center mb-5">
                <button
                  onClick={handlePreviousStep}
                  className="btn btn-back me-3"
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <h2 className="step-title">Detalle de tu pedido</h2>
              </div>
              <div className="card shadow-sm p-4 mb-4">
                <span>Plan</span>
                {/* Corrección: Se accede a la propiedad 'nombre' del objeto 'selectedPlanData' */}
                <h4 className="plan-name">{selectedPlanData.nombre}</h4>
                <hr className="mb-4" />
                <h4 className="summary-title">Resumen del pedido</h4>
                <div className="d-flex justify-content-between summary-item my-2">
                  <span className="summary-label">Total</span>
                  {/* Corrección: Se accede a la propiedad 'precioTotal' del objeto 'selectedPlanData' */}
                  <span className="summary-value summary-total">
                    {selectedPlanData.precioTotal}
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between summary-item my-2">
                  <span className="summary-label">Costo x mes</span>
                  {/* Corrección: Se accede a la propiedad 'costoMes' del objeto 'selectedPlanData' */}
                  <span className="summary-value">
                    {selectedPlanData.costoMes}
                  </span>
                </div>
                <div className="d-flex justify-content-between summary-item my-2">
                  <span className="summary-label">Descuento</span>
                  {/* Corrección: Se accede a la propiedad 'descuento' del objeto 'selectedPlanData' */}
                  <span className="summary-value">
                    {selectedPlanData.descuento}
                  </span>
                </div>
                <div className="d-flex justify-content-between summary-item my-2">
                  <span className="summary-label">IGV</span>
                  {/* Corrección: Se accede a la propiedad 'igv' del objeto 'selectedPlanData' */}
                  <span className="summary-value">{selectedPlanData.igv}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between summary-item my-2">
                  <span className="summary-label">Nota*&nbsp;</span>
                  <span className="summary-value">
                    {selectedPlanData.frecuencia}
                  </span>
                </div>
              </div>
              <div className="w-100 text-center">
                {selectedPlanData.precio === "Gratis" ? (
                  <button
                    onClick={() =>
                      handlePaymentSubmit(null, selectedPlanData.id)
                    }
                    className="btn-primary btn-crear-grupo mt-4"
                  >
                    Crear Grupo (Gratis)
                  </button>
                ) : (
                  <button
                    onClick={handlePayClick}
                    className="btn-primary btn-crear-grupo mt-4"
                  >
                    Pagar
                  </button>
                )}
              </div>
            </div>
          </div>
        );

      default:
        return <div>Paso no encontrado.</div>;
    }
  };

  return (
    <div className="crear-grupo-container">
      {renderPaso()}

      {/* Modal de Pago (Se asume que llama a handlePaymentSubmit) */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onPaymentSubmit={handlePaymentSubmit}
      />

      {/* Modal de Resultado (Éxito/Error/Advertencia) */}
      <CustomModal
        isOpen={showResultModal}
        title={resultModalTitle}
        message={resultModalMessage}
        type={resultModalType}
        onClose={handleResultModalClose}
      />

      {/* --- IMPLEMENTACIÓN DEL MODAL DE LOADING --- */}
      <LoadingModal
        isOpen={showLoadingModal}
        message={
          pasoActual === 2
            ? "Verificando tu plan activo..."
            : "Procesando pago y creando grupo..."
        }
      />
      {/* ------------------------------------------- */}
    </div>
  );
};

export default CrearGrupo;
